import React from 'react';
import { useSelector } from 'react-redux';

import { propertyUtils } from '@zg-rentals/rental-manager-env';

import ForRentByFieldSet from './ForRentByFieldSet';
import { WizardBody, WizardFormSectionContainer, WizardHeading } from '../../../../styles/wizard';

const propTypes = {};
const defaultProps = {};

const FormSectionContainer = () => {
  const currentProperty = useSelector((state) => state.properties.currentProperty);
  const isRoomForRent = propertyUtils.isRoomForRent({ currentProperty });

  const heading = isRoomForRent ? 'Who is the contact person?' : `Who’s listing this property for rent?`;

  return (
    <WizardFormSectionContainer data-testid="FormSectionContainer">
      <WizardHeading level={1} textStyle="heading-sm">
        {heading}
      </WizardHeading>

      <WizardBody>
        Enter your information, unless you&apos;re creating the listing for someone else and they should be the main
        contact person.
      </WizardBody>

      <ForRentByFieldSet />
    </WizardFormSectionContainer>
  );
};

FormSectionContainer.propTypes = propTypes;
FormSectionContainer.defaultProps = defaultProps;

export default FormSectionContainer;
